import { useState } from 'react';
import { useEffect } from 'react';
import { PieChart, Pie, Cell } from 'recharts';

const data = {
  mass_followers: { color: '#513DA3', label: 'Mass Followers' },
  suspicious: { color: '#3A2C75', label: 'Suspicious Accounts' },
  influencers: { color: '#9D89F0', label: 'Influencers' },
  real: { color: '#D5CDF8', label: 'Real People' },
};

export default function AudienceType({ audienceTypeData }) {
  const [pieData, setPieData] = useState(undefined);

  useEffect(() => {
    const d = audienceTypeData
      ?.sort((a, b) => {
        const x = a.weight;
        const y = b.weight;
        return x > y ? -1 : x < y ? 1 : 0;
      })
      ?.map(({ code, weight }) => ({
        name: data[code].label,
        value: weight,
        color: data[code].color,
      }));
    setPieData(d);
  }, [audienceTypeData]);

  if (!pieData) {
    return null;
  }

  return (
    <div className="demographics-card">
      <h2>Audience Quality Breakdown</h2>
      <div className="audience-type-container">
        <div className="left-container">
          <PieChart width={150} height={200}>
            <Pie data={pieData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={75}>
              {pieData &&
                pieData?.map((data, index) => <Cell key={`cell-${index}`} fill={data.color} strokeWidth={0} />)}
            </Pie>
          </PieChart>
        </div>
        <div className="right-container">
          {pieData.map((data, index) => (
            <div className="audience-type-legend" key={index}>
              <p className="legend-name">
                <span style={{ backgroundColor: data.color }} />
                {data.name}
              </p>
              <p className="legend-value">{(data.value * 100).toFixed(2)}%</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
